<template>
  <div class="role-page page-center">
    <div class="show-00" ref="show00">
      <CareeringSubheader />
    </div>
    <div class="show-01" ref="show01">
      <!-- <div class="header-divider"></div> -->
      <div class="spacer"></div>
      <div class="spacer"></div>
      <div class="spacer"></div>
    </div>
    <div class="roles padded-width align-left">
      <div class="show-02" ref="show02">
        <Back go="/careering" label="Roles" />
      </div>
      <div class="show-03" ref="show03">
        <component :is="renderedRole"></component>
      </div>
    </div>
  </div>
</template>

<script>
import BackendEngineer from "./Roles/BackendEngineer.vue";
import iOSEngineer from "./Roles/iOSEngineer.vue";
import ContentStrategist from "./Roles/ContentStrategist.vue";
import CreateRole from "./Roles/CreateARole.vue";
import NotFound from "./NotFound.vue";
import Back from "./Back.vue";
import CareeringSubheader from "./CareeringSubheader.vue";
import { mapState } from "vuex";

export default {
  name: "Role",
  components: {
    BackendEngineer,
    iOSEngineer,
    CreateRole,
    NotFound,
    Back,
    CareeringSubheader,
    ContentStrategist
  },
  data() {
    return {
      lastRoleComponent: null,
      renderedRole: null,
    };
  },
  computed: {
    ...mapState(["previousRoute"]),
  },
  created() {
    this.checkRole();
  },
  methods: {
    checkRole() {
      let component = "NotFound";
      switch (this.$route.params.role) {
        case "backend-engineer":
          component = "BackendEngineer";
          break;
        case "create-a-role":
          component = "CreateRole";
          break;
        case "ios-engineer":
          component = "iOSEngineer";
          break;
        case "content-strategist":
          component = "ContentStrategist";
          break;
        default:
          break;
      }
      // if the component is found, we update the lastRoleComponent
      if (component !== "NotFound") {
        this.lastRoleComponent = component;
      }
      // if the component is NotFound, we return the last valid role component
      this.renderedRole =
        component === "NotFound" ? this.lastRoleComponent : component;
    },
  },
  mounted() {
    let delay = this.previousRoute.name ? 850 : 50;
    setTimeout(() => {
      this.$refs.show00.classList.add("show");
      this.$refs.show01.classList.add("show");
      this.$refs.show02.classList.add("show");
      this.$refs.show03.classList.add("show");
    }, delay);
  },
  watch: {
    "$route.params.role": function (role) {
      this.checkRole();
    },
  },
};
</script>
<style>
.header-divider {
  width: 100%;
  height: 2px;
  background-color: #4C4C4C;
  margin-top: 4rem;
}

.show-01,
.show-02,
.show-03 {
  width: 100%;
  opacity: 0;
  transform: translateY(1.6rem);
  transition: all 350ms ease-in-out;
}

.show-00 {
  transition-delay: 0ms;
}

.show-01 {
  transition-delay: 75ms;
}

.show-02 {
  transition-delay: 150ms;
}

.show-03 {
  transition-delay: 200ms;
}

.show-01.show,
.show-02.show,
.show-03.show {
  opacity: 1;
  transform: translateY(0);
}
</style>